import React, { Fragment } from 'react'
import { PagerButton, Voiceover, Intro } from 'cvs-core'
import img1 from '../../assets/images/U1-T1-3a.svg'
import img2 from '../../assets/images/U1-T1-3b.svg'
import img3 from '../../assets/images/U1-T1-3c.svg'
import img4 from '../../assets/images/U1-T1-3d.svg'
import voAudio from '../../assets/vo/Prepare-Your-Habits-01.mp3'

const vo = {
  sources: [
    {
      src: voAudio,
    },
  ],
  transcript:
    'Read and think about the following questions and reflect on your own behaviors and habits.',
}

export default {
  title: 'Your Habits',
  path: '/prepare/your-habits',
  content: (
    <Fragment>
      <Voiceover {...vo} />
      <Intro
        title="Your Habits"
        direction="Read and think about the following questions and reflect on your own behaviors and habits. Have any of these happened to you?"
      />
      <article>
        <img
          src={img1}
          alt=""
          className="img-center"
          height="235"
          width="568"
        />
        <p className="text-center">
          Have you seen friends or classmates vaping?
        </p>

        <img
          src={img2}
          alt=""
          className="img-center"
          height="235"
          width="568"
        />
        <p className="text-center">Have you ever been offered to try a vape?</p>

        <img
          src={img3}
          alt=""
          className="img-center"
          height="235"
          width="568"
        />
        <p className="text-center">Do you think vaping is safe?</p>

        <img
          src={img4}
          alt=""
          className="img-center"
          height="235"
          width="568"
        />
        <p className="text-center">
          Have you had to stand up to peer pressure to do something you did not
          think was right/safe?
        </p>

        <p className="text-center">
          The choices you make every day can have a big effect on your life now
          and in the future. You’ll learn more in the module about how you can
          make good decisions for yourself.
        </p>
      </article>

      <PagerButton />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Prepare/YourHabits.js